/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

const PartnerList = ({ eventId }) => {
  const glowCount = [1, 2, 3, 4];
  const [activeTab, setactiveTab] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [partnerList, setPartnerList] = useState([]);

  //function for get all event members
  const getAllEventPartners = async (roleSlug) => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GUEST_ALL_EVENT_PARTNERS +
        `?event=${eventId}&isallparticipants=${true}&partnerroleslug=${roleSlug}`;

      const response = await getData(requestUrl);

      // console.log(response);
      setIsLoading(false);
      if (response.status) {
        setPartnerList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (eventId) {
      setactiveTab("organizer");
      getAllEventPartners("ORGANIZER");
    }
  }, []);

  return (
    <div className="partner_sec">
      <div className="tab_links">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link text-primary text-uppercase fw-semibold fs-sm ${
                activeTab == "organizer" ? "active" : ""
              }`}
              onClick={() => {
                setactiveTab("organizer");
                getAllEventPartners("ORGANIZER");
              }}
            >
              ORGANIZER
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link text-primary text-uppercase fw-semibold fs-sm ${
                activeTab == "coorganizer" ? "active" : ""
              }`}
              onClick={() => {
                setactiveTab("coorganizer");
                getAllEventPartners("COORGANIZER");
              }}
            >
              CO-ORGANIZER
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link text-primary text-uppercase fw-semibold fs-sm ${
                activeTab == "academic" ? "active" : ""
              }`}
              onClick={() => {
                setactiveTab("academic");
                getAllEventPartners("ACADEMICPARTNER");
              }}
            >
              ACADEMIC PARTNER
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link text-primary text-uppercase fw-semibold fs-sm ${
                activeTab == "mediallies" ? "active" : ""
              }`}
              onClick={() => {
                setactiveTab("mediallies");
                getAllEventPartners("MEDIAALLIES");
              }}
            >
              MEDIA ALLIES
            </button>
          </li>
        </ul>
      </div>

      <div className="partner_outer">
        {isLoading ? (
          <div className="row">
            {glowCount.map((count, index) => {
              return (
                <div className="col-lg-3 mb-4" key={index}>
                  <div className="partner_bx bg_white text-center">
                    <Link
                      to="#"
                      className="partner_logo d-flex align-items-center justify-content-center placeholder placeholder-sm text-gray"
                    ></Link>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="row">
            {partnerList.map((sponsor, index) => {
              return (
                <div className="col-lg-3 mb-4" key={index}>
                  <div className="partner_bx bg_white text-center">
                    <Link
                      to="#"
                      className="partner_logo d-flex align-items-center justify-content-center"
                    >
                      <img
                        src={
                          sponsor.image == ""
                            ? ""
                            : url.SERVER_URL + sponsor.image
                        }
                        alt=""
                      />
                    </Link>
                    <p>{sponsor.name}</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnerList;
